import dayjs from "@/utils/dayjs";

export default (
  aStart: string | dayjs.Dayjs,
  aEnd: string | dayjs.Dayjs | null,
  bStart: string | dayjs.Dayjs,
  bEnd: string | dayjs.Dayjs | null,
): boolean => {
  if (!aEnd && !bEnd) return true;
  if (!aEnd) return dayjs.strict(bEnd!).isSameOrAfter(aStart);
  if (!bEnd) return dayjs.strict(aEnd!).isSameOrAfter(bStart);

  return (
    dayjs.strict(aStart!).isSameOrBefore(bEnd) &&
    dayjs.strict(bStart!).isSameOrBefore(aEnd)
  );
};
